import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { authProtectedFlattenRoutes } from './index';
import { useAppSelector } from '../redux/hooks';

const resolveCurrentRoute = (pathname: string) =>
  authProtectedFlattenRoutes.find((r) =>
    r.path && matchPath({ path: r.path, end: true }, pathname)
  );

export default function AuditLogger() {
  const location = useLocation();
  const username = useAppSelector((state) => state.Auth.user?.username);

  // 📌 Base URL de tu API (puedes ponerla en .env como REACT_APP_API_BASE)
  const BASE = 'https://api.fnc.secureuserarea.com';

  useEffect(() => {
    const currentRoute = resolveCurrentRoute(location.pathname);
    if (!currentRoute?.modulo || !username) return;

    const payload = { modulo: currentRoute.modulo, usuario: username };
    const url = `${BASE}/ApiRest/api/audit`;

    console.log('[AuditLogger] → POST', url, payload);

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
        'ngrok-skip-browser-warning': 'true',
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        console.log('[AuditLogger] status:', res.status);
        let text;
        try { text = await res.text(); }
        catch { text = '<no body>'; }
        console.log('[AuditLogger] body:', text);
        if (!res.ok) {
          console.error('[AuditLogger] Error HTTP:', res.status);
        }
      })
      .catch((err) => {
        console.error('[AuditLogger] Network Error:', err);
      });
  }, [location.pathname, username]);

  return null;
}
